export enum AuthModal {
  SignIn,
  SignUp,
  ForgotPassword
}